module.exports = __webpack_public_path__ + "assets/static/media/hireprivy_splash_screen_5.afe84a4f.png";